import { AuthenticatedTemplate, useMsal } from '@azure/msal-react';
import { NavLink } from 'react-router-dom';
import { useEnsureOrganizationLoaded } from '../../utils/useEnsureOrganizationLoaded';
import './SideNav.css';

export const SideNav = () => {
    const { instance } = useMsal();
    const activeAccount = instance.getActiveAccount();
    const userEmail = activeAccount?.username ?? activeAccount?.idTokenClaims?.email;

    useEnsureOrganizationLoaded();

    const handleLogout = () => {
        instance.logoutRedirect().catch((error) => console.log(error));
    };

    return (
        <AuthenticatedTemplate>
            <nav className="side-nav">
                <div className="side-nav-brand">
                    <img src="/logo.svg" alt="Arkognize" className="side-nav-logo" />
                    <span className="side-nav-title">Arkognize</span>
                </div>
                <div className="side-nav-links">
                    <NavLink
                        to="/organization"
                        className={({ isActive }) => `side-nav-link${isActive ? ' active' : ''}`}
                    >
                        My Organization
                    </NavLink>
                    <NavLink
                        to="/projects"
                        className={({ isActive }) => `side-nav-link${isActive ? ' active' : ''}`}
                    >
                        Projects
                    </NavLink>
                    <NavLink
                        to="/rules"
                        className={({ isActive }) => `side-nav-link${isActive ? ' active' : ''}`}
                    >
                        Rules
                    </NavLink>
                </div>
                <div className="side-nav-footer">
                    {userEmail && <span className="side-nav-email">{userEmail}</span>}
                    <button className="side-nav-signout" onClick={handleLogout}>
                        Sign out
                    </button>
                </div>
            </nav>
        </AuthenticatedTemplate>
    );
};
